import { api } from "../api";

export const authService = api.injectEndpoints({
  endpoints: (build) => ({
    checkToken: build.query<void, string>({
      query: () => ({
        url: "/auth/check-token",
        method: "POST"
      })
    }),
  })
});

export const {
  useCheckTokenQuery
} = authService;